/**
 *
 * @param plantAntal Antal plantor i heltal, exempelvis 1500
 * @param arealsAndel Antal procent av nettoArealen i heltal mellan 0-100, exempelvis 25
 * @param nettoAreal Antal hektar i decimaltal, exempelvis 5.25
 * @returns Antal mål i plantor per hektar
 * Infinity, NaN och tillåts inte, 0 returneras istället.
 * Om uträkningen krashar (exempelvis om något värde är undefined), returneras 0
 *
 * Vanligt flöde:
 * 1500, 25, 5.25
 * 1500 / (5.25 * 0.25)
 * 1500 / 1.3125
 * Resultat: 1142,8571428571428571428571428571
 * Avrundat: 1142
 */
export const malPlHaCalculation = (plantAntal: number, arealsAndel: number, nettoAreal: number): number => {
    try {
        const result = Math.floor(plantAntal / (nettoAreal * (arealsAndel / 100)));
        if (Number.isFinite(result)) {
            return result;
        }
        return 0;
    } catch {
        return 0;
    }
};

export const plantAntalCalculation = (malPlantorHA: number, arealsAndel: number, nettoAreal: number): number => {
    try {
        const result = Math.floor(malPlantorHA * (arealsAndel / 100) * nettoAreal);
        if (Number.isFinite(result)) {
            return result;
        }
        return 0;
    } catch {
        return 0;
    }
};

export const arealandelCalculation = (malPlantorHA: number, plantantal: number, nettoAreal: number): number => {
    try {
        const result = Math.floor(plantantal / (malPlantorHA * nettoAreal) * 100);
        if (Number.isFinite(result)) {
            return result;
        }
        return 0;
    } catch {
        return 0;
    }
};
